import { GzBulkActionsBarWebComponent } from './component/GzBulkActionsBarWebComponent';

export { GzBulkActionsBarWebComponent };
